module.exports = __webpack_public_path__ + "static/img/zxyh.0d5f2f04.png";